module.exports = __webpack_public_path__ + "96cca3298724eeac307f21cb4ddae43d.svg";